import {TournamentLite} from "../models/Tournament";

export const formatTournamentStatus = (tournament: TournamentLite) => (
    (tournament.status === "Playing") ?
        <span>{tournament.status} (round {tournament.cur_round} of {tournament.num_rounds})</span> :
        <span>{tournament.status} ({tournament.num_rounds} rounds)</span>
);
